import { useEffect } from "react";
import { LegalPage } from "@/components/landing/LegalPage";

export default function Widerruf() {
  useEffect(() => {
    document.title = "Widerruf — Positivup";
  }, []);
  return <LegalPage doc="widerruf" />;
}
